import { useState, useEffect } from "react";
import { apiGetHowToLPData } from "Root/api/apiCheckout";
const useHowToUseData = () => {
    const [routine, setRoutine] = useState(null);
    const [assignedRd, setAssignedRd] = useState(null);
    useEffect(() => {
        const getHowToLPData = async () => {
            const data = await apiGetHowToLPData();
            if (data) {
                if (data.workout_routine) {
                    const routineData = Object.entries(data.workout_routine).map(([key, value]) => ({
                        title: key === "workout" ? `${data.workout_time} Workout Day` : "Rest Day",
                        products: value,
                    }));
                    setRoutine(routineData);
                }
                setAssignedRd(data.assigned_rd);
            }
        };
        getHowToLPData();
    }, []);
    return {
        routine,
        assignedRd,
    };
};
export default useHowToUseData;
